'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.getTrackingService = exports.registerTrackingService = void 0;
var serviceNotSet = function () {
    return console.error('Error: Tracking service is not correctly configured. Use registerTrackingService before app creation.');
};
// Default tracking service that is a `noop` essentially.
var trackingService = new Proxy({}, {
    get: serviceNotSet,
});
function registerTrackingService(service) {
    trackingService = service;
}
exports.registerTrackingService = registerTrackingService;
function getTrackingService() {
    return trackingService;
}
exports.getTrackingService = getTrackingService;
